import { useContext } from 'react';
import { ThemeContext } from './ThemeProvider';
import type { Theme } from '@/shared/lib/theme';

export type { Theme };

/**
 * Consume the current theme + setTheme from within a ThemeProvider tree.
 *
 * Throws when called outside a ThemeProvider so callers get an explicit error
 * rather than silent undefined behaviour.
 */
export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return ctx;
}
